import React from 'react';

const SelectField = (
    { input, multiple, icon, label, options, className, placeholder, disabled, meta: { asyncValidating, touched, error } },
) => {
    const hasError = touched && error;
    const invalidClassName = hasError ? 'invalid' : '';

    return (
        <div className={`form-group ${invalidClassName}`}>
            {label &&
                <label className="form-control-label">{label}</label>
            }
            <select
                {...input}
                className={className}
                placeholder={placeholder}
                disabled={disabled}
                multiple={multiple}>
                <option />
                {options}
            </select>
            {hasError &&
                <div className="text-danger small pt-2 pl-2 animated flash">{error}</div>
            }
        </div>
    );
};

export default SelectField;



// WEBPACK FOOTER //
// ./src/components/SelectField.js